import { useActivityEditFormContext, useUpdateCustomFieldValue } from "../activity_edit_form_context";

export const useUpdateActivityCustomFieldValue = () => {
  const { setMetadata, setCustomFields, subtemplate } = useActivityEditFormContext();

  return useUpdateCustomFieldValue({ setMetadata, setCustomFields, subtemplate });
};
